import { Dispatch, SetStateAction } from "react";
import { SelectProps } from "@amzn/awsui-components-react";
export interface ICreateTaskFormProps {
  parentTaskId: string;
  setVisible: Dispatch<SetStateAction<boolean>>;
  resetForm: number;
  parentCategory: string;
  gaiaObjectId?: string;
  onCreate?: (taskData: any) => void;
  // Submit button label; defaults to "Create" for the standalone form page.
  // Modal-based callers (e.g., draft wizard's task suggestions) pass "Add".
  submitLabel?: string;
}

export interface CreateTaskFormResponse {
  taskId: string;
}

export enum TaskStatus {
  NotStarted = "Not started",
  InProgress = "In progress",
  OnHold = "On hold",
  Complete = "Complete",
  PendingCustomerAction = "Pending customer action",
  Cancelled = "Cancelled",
}

export enum WorkType {
  Manual = "Manual",
  Agentic = "Agentic",
}

export const WORK_TYPE_OPTIONS = [
  { label: WorkType.Manual, value: WorkType.Manual },
  { label: WorkType.Agentic, value: WorkType.Agentic },
];

export type StatusChangeEvent = Parameters<
  Required<SelectProps>["onChange"]
>[0];
